import {None} from "./None";
import {useRef, useState} from "react";
import {TaskPopover} from "./TaskPopover";
import {StaticDatePicker} from "@mui/x-date-pickers";
import {Chip, TextField} from "@mui/material";
import moment from "moment";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../misc/SyncedRef";
import {ArrowDropDown, CalendarToday} from "@mui/icons-material";

export function TaskDueDate(props: {
    value: string | null;
    onChange(v: string | null): Promise<any>;
}) {
    const [show, setShow] = useState(false);
    const anchorEl = useRef<HTMLDivElement|null>(null);
    const onChangeRef = useSyncedRef(props.onChange);
    const updateCb = useAsyncAction(async (v) => {
        await onChangeRef.current(v);
        setShow(false);
    }, [])

    return (
        <>
            <div ref={anchorEl} style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 4,
                fontSize: "0.8rem",
            }}>
                {!props.value && <None onClick={() => setShow(true)}>
                    No Due Date
                </None>}
                {props.value && <Chip
                    icon={<CalendarToday />}
                    label={"Due: " + moment(props.value).format("YYYY-MMM-DD")}
                    onClick={() => setShow(true)}
                    onDelete={() => setShow(true)}
                    deleteIcon={<ArrowDropDown />}
                    size="small"
                    color={
                        moment(props.value).isBefore(moment()) ? "error" as "error" :
                            moment(props.value).isBefore(moment().add(1, "day")) ? "warning" as "warning" : undefined}
                />}
            </div>
            {show && <TaskPopover
                title="Manage Tags" anchorEl={anchorEl.current}
                onClose={() => setShow(false)}

            >
                <StaticDatePicker
                    onChange={v => {
                        if(!v) return;
                        updateCb.callback(v.toISOString())
                    }}
                    value={props.value ? moment(props.value) : null}
                    openTo="day"
                    renderInput={r => <TextField {...r} />}
                    componentsProps={{
                        // pass props `actions={['clear']}` to the actionBar slot
                        actionBar: { actions: [] },
                    }}
                />
                {updateCb.LoadingElement}
            </TaskPopover>}
        </>
    )
}